import { useAuth } from './useAuth';
import { userHasFeature, getRequiredTier, getTierConfig } from '../constants/tiers';

/**
 * Hook to check if the current user has access to a feature.
 *
 * Usage:
 *   const { hasAccess, requiredTier } = useFeatureAccess('launchVolumeForecaster');
 */
export function useFeatureAccess(featureKey) {
  const { user } = useAuth();
  const tier = user?.tier || 'trial';
  const isAdmin = user?.role === 'admin';

  return {
    hasAccess: isAdmin || userHasFeature(tier, featureKey),
    requiredTier: getRequiredTier(featureKey),
    requiredTierConfig: getTierConfig(getRequiredTier(featureKey)),
    userTier: tier,
  };
}
